import React, { FC } from "react";
import styles from "./About.module.scss";
import Image from "next/image";
import { F_Open_Sans } from "@/fonts";
import { HiDocumentDownload } from "react-icons/hi";
import { FaGithub } from "react-icons/fa";
import { AiFillLinkedin } from "react-icons/ai";
import Link from "next/link";

const About: FC = () => {
  return (
    <div id="About" className={styles.about}>
      <div className={styles.image}>
        <Image priority src="/me-3.jpg" fill alt="myPhoto" />
      </div>

      <div className={`${styles.text} ${F_Open_Sans.className}`}>
        <h1 className={styles.title}>About me</h1>
        <p className={styles.desc}>
          I’m a front-end developer with nearly 3 years of experience creating
          dynamic, user-friendly web applications. I work with React, Next.js,
          Vue.js, Solid.js, TypeScript, Tailwind CSS, SCSS, MUI, Bootstrap, and
          WebGi. I’m passionate about transforming designs into interactive,
          high-quality digital experiences and am open to freelance or full-time
          opportunities in front-end development.
        </p>
        <div className={styles.socials}>
          <Link
            href="/cv-2.pdf"
            download="cv"
            target="_blank"
            className={styles.socialsButton}
          >
            <HiDocumentDownload /> <span>Resume</span>
          </Link>
          <Link
            href="https://github.com/Jasminamih"
            target="_blank"
            className={styles.socialsButton}
          >
            <FaGithub /> <span>Github</span>
          </Link>
          <Link
            href="https://www.linkedin.com/in/jasmina-mihajloska-170b37148/"
            target="_blank"
            className={styles.socialsButton}
          >
            <AiFillLinkedin /> <span>Linkedin</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
